import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ProtectedRoute from "@/components/ProtectedRoute";
import AuthCallback from "@/components/AuthCallback";

import Home from "@/pages/Home";
import Pricing from "@/pages/Pricing";
import Certification from "@/pages/Certification";
import Advertising from "@/pages/Advertising";
import Events from "@/pages/Events";
import Directory from "@/pages/Directory";
import BarberProfile from "@/pages/BarberProfile";
import Marketplace from "@/pages/Marketplace";
import RealRazors from "@/pages/RealRazors";
import Reserve from "@/pages/Reserve";
import News from "@/pages/News";
import Article from "@/pages/Article";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Policy from "@/pages/Policy";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";

function Shell() {
  const location = useLocation();

  // Handle Google OAuth callback FIRST (synchronous check before routing).
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }

  const bare = ["/login", "/register"].includes(location.pathname);

  return (
    <div className="grain min-h-screen flex flex-col bg-[#050505]">
      {!bare && <Navbar />}
      <main className={`flex-1 ${!bare ? "pt-16" : ""}`}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/certification" element={<Certification />} />
          <Route path="/advertising" element={<Advertising />} />
          <Route path="/events" element={<Events />} />
          <Route path="/directory" element={<Directory />} />
          <Route path="/marketplace" element={<Marketplace />} />
          <Route path="/rr" element={<RealRazors />} />
          <Route path="/reserve" element={<Reserve />} />
          <Route path="/barber/:id" element={<BarberProfile />} />
          <Route path="/news" element={<News />} />
          <Route path="/article/:slug" element={<Article />} />
          <Route path="/policy/:slug" element={<Policy />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
        </Routes>
      </main>
      {!bare && <Footer />}
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Shell />
        <Toaster position="top-right" theme="dark" />
      </AuthProvider>
    </BrowserRouter>
  );
}
